var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0288 17.8876H18.3748",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1825 3.32044C11.8612 2.50931 13.0812 2.39037 13.9092 3.05527C13.955 3.09134 15.4258 4.23394 15.4258 4.23394C16.3354 4.78379 16.618 5.95272 16.0557 6.84477C16.0259 6.89254 7.71045 17.2939 7.71045 17.2939C7.4338 17.639 7.01385 17.8428 6.56504 17.8477L3.38059 17.8876L2.66309 14.8508C2.56258 14.4238 2.66309 13.9753 2.93974 13.6302L11.1825 3.32044Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64307 5.25073L14.4138 8.91447",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilMark);
export default __webpack_public_path__ + "static/media/pencil-mark.68e2e4e065e7cdfb6d77b6cc8ca34822.svg";
export { ForwardRef as ReactComponent };